"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var debounce_1 = require("@vwfs-uix/core/dist/utils/debounce");
var SteppedSelector = /** @class */ (function () {
    function SteppedSelector(el) {
        var _this = this;
        var _a;
        this.selectedAnswers = [];
        this.selectedStep = 0;
        // persist state in session storage (delay to make sure event handlers are done)
        this.persistState = (0, debounce_1.debounce)(function () {
            sessionStorage.setItem("steppedSelector-".concat(_this.id), JSON.stringify({
                lastModified: _this.el.dataset.lastModified,
                selectedAnswers: _this.selectedAnswers,
                selectedStep: _this.component.currentIndex,
            }));
        }, 300);
        this.el = el;
        this.id = el.id;
        this.advanced = el.dataset.advanced === 'true';
        // eslint-disable-next-line
        this.component = bronson.$$(this.el).component('stepped-selector').items[0];
        this.el.querySelectorAll('fieldset[data-step]').forEach(function (step, index) {
            step.querySelectorAll('input[type="radio"]').forEach(function (radio) {
                radio.addEventListener('click', function () {
                    // remove current and all following answers
                    var i = _this.selectedAnswers.findIndex(function (answer) { return answer.stepId === step.id; });
                    if (i >= 0) {
                        _this.selectedAnswers = _this.selectedAnswers.slice(0, i);
                    }
                    // add new answer
                    var label = radio.closest('.c-radio');
                    _this.selectedAnswers.push({
                        stepId: step.id,
                        index: index,
                        id: label === null || label === void 0 ? void 0 : label.id,
                        text: radio.dataset.altText ? radio.dataset.altText : label.textContent,
                        results: radio.dataset.results ? radio.dataset.results.split(',') : null,
                    });
                    // enable follow-up question (either configured or next one)
                    _this.enableFollowupStep(index, radio.dataset.followQuestion);
                    // update and persist state
                    _this.updateSelectedAnswers();
                    _this.updateResults();
                    _this.persistState();
                });
            });
        });
        // persist state when changing step
        this.el.addEventListener('click', function (event) {
            if (!event.target.closest('button')) {
                return;
            }
            _this.persistState();
        });
        // reset questions and selected answers
        (_a = this.el.querySelector('.c-stepped-selector__reset')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function () {
            _this.selectedAnswers = [];
            _this.selectedStep = 0;
            _this.updateSelectedAnswers();
            _this.toggleStepsAfter(0, true);
            _this.updateResults();
            _this.persistState();
        });
        this.loadState();
    }
    // disable all questions after given index
    SteppedSelector.prototype.toggleStepsAfter = function (index, disabled) {
        this.el.querySelectorAll('fieldset[id][data-step]:not(.c-stepped-selector__results)').forEach(function (step, i) {
            if (i > index) {
                step.setAttribute('aria-disabled', disabled ? 'true' : 'false');
                step.querySelectorAll("input[type=\"radio\"]").forEach(function (radio) { return (radio.checked = false); });
            }
        });
    };
    SteppedSelector.prototype.toggleStep = function (id, disabled) {
        var _a;
        (_a = this.el.querySelector("fieldset[data-step]#".concat(id))) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    };
    SteppedSelector.prototype.updateSelectedAnswers = function () {
        var _this = this;
        var selectionListEl = this.el.querySelectorAll(".c-stepped-selector__selection-list");
        selectionListEl.forEach(function (selectionList) {
            selectionList.innerHTML = '';
            _this.selectedAnswers.sort(SteppedSelector.compare).forEach(function (answer) {
                var li = document.createElement('li');
                li.innerHTML = "<i class=\"c-icon-list__icon c-icon c-icon--[semantic-checkmark]\" aria-hidden=\"true\"></i>\n                    <span class=\"u-visually-hidden\">Included: </span>\n                    <a href=\"#".concat(answer.stepId, "\" data-step-index=\"").concat(answer.index, "\">").concat(answer.text, "</a>");
                selectionList.append(li);
            });
        });
    };
    SteppedSelector.prototype.updateResults = function () {
        var resultElements = this.el.querySelectorAll('.js-stepped-selector__result > .c-card, .js-stepped-selector__result > .o-content-section');
        var noResultElement = this.el.querySelector('.js-stepped-selector__no-result');
        var results = [];
        // collect all available result IDs
        resultElements.forEach(function (el) { return results.push(el.id); });
        // reduce results to those selected by user
        results = this.selectedAnswers.reduce(function (acc, answer) {
            // if answer has no results selected, assume all results are valid
            if (!answer.results) {
                return acc;
            }
            return acc.filter(function (result) { return answer.results.includes(result); });
        }, results);
        // enable/disable cards based on collected results
        resultElements.forEach(function (el) {
            var parentEl = el.closest('.js-stepped-selector__result');
            if (results.includes(el.id)) {
                parentEl.classList.remove('u-hide');
                parentEl.removeAttribute('aria-hidden');
            }
            else {
                parentEl.classList.add('u-hide');
                parentEl.setAttribute('aria-hidden', 'true');
            }
        });
        if (results.length > 0) {
            noResultElement.classList.add('u-hide');
            noResultElement.setAttribute('aria-hidden', 'true');
        }
        else {
            noResultElement.classList.remove('u-hide');
            noResultElement.removeAttribute('aria-hidden');
        }
    };
    SteppedSelector.prototype.enableFollowupStep = function (stepIndex, followupQuestionId) {
        var _a;
        if (this.advanced) {
            this.toggleStepsAfter(stepIndex, true);
            if (followupQuestionId) {
                (_a = this.el.querySelector("#".concat(followupQuestionId))) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-disabled', 'false');
            }
        }
        else {
            this.toggleStepsAfter(stepIndex, false);
            this.toggleStepsAfter(stepIndex + 1, true);
        }
    };
    SteppedSelector.prototype.loadState = function () {
        var state = JSON.parse(sessionStorage.getItem("steppedSelector-".concat(this.id)) || '{}');
        if (state.lastModified == this.el.dataset.lastModified) {
            this.selectedAnswers = state.selectedAnswers || [];
            this.selectedStep = state.selectedStep || 0;
            this.restoreState();
        }
        else {
            this.selectedAnswers = [];
            this.selectedStep = 0;
        }
    };
    SteppedSelector.prototype.restoreState = function () {
        var _this = this;
        // disable all steps except the first one
        this.toggleStepsAfter(0, true);
        // for each answer, enable corresponding step and check radio button
        this.selectedAnswers.forEach(function (answer) {
            var radio = _this.el.querySelector("#".concat(answer.id, " input[type=\"radio\"]"));
            radio.checked = true;
            _this.toggleStep(answer.stepId, false);
            _this.enableFollowupStep(answer.index, radio.dataset.followQuestion);
            _this.component.updateControlState();
        });
        this.updateSelectedAnswers();
        this.updateResults();
        this.component.goTo(this.selectedStep);
    };
    SteppedSelector.compare = function (a, b) {
        return a.index < b.index ? -1 : 1;
    };
    return SteppedSelector;
}());
document.addEventListener('DOMContentLoaded', function () {
    // delay to ensure Bronson component is fully initialized first
    setTimeout(function () {
        document.querySelectorAll('.js-stepped-selector').forEach(function (steppedSelectorEl) {
            new SteppedSelector(steppedSelectorEl);
        });
    }, 300);
});
